import React from "react"
import SignupLayout from ".";
import BackgroundImg from "../../assets/images/background/02-set-password.png";
import { AiChipsSignup, CheckIcon, SetPasswordIcon } from "../../components/Icons/iconImages";
import InputField from "../../components/InputField";
import { validationConstants } from "../../constants/validations";
import { Button } from "antd";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Icons from '../../components/Icons';
import { getDomain } from "../../helper";

const SetPassword = () => {
    const navigate = useNavigate();
    const defaultValues = {
        password: '',
        confirmPassword: ""
    };
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues,
    });

    // 👀 Watch password value
    const password = useWatch({
        control,
        name: "password",
    });

    // ✅ Validation conditions in realtime
    const isMinLength = password?.length >= 8;
    const hasSpecialChar = /[^A-Za-z0-9]/.test(password || "");

    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleSignUp = async () => {
        // Check if demo domain - skip onboarding for demo users
        const domain = getDomain();
        if (domain === 'demo') {
            navigate('/conversation');
        } else {
            navigate('/about-your-company');
        }
    };

    const handleSubmitError = (data: any) => {
        // console.log('error triggered', data)
    };

    return (
        <SignupLayout
            title={<p className="text-[#FFFFFF] font-bold text-6xl 2xl:text-7xl mt-3">Your AI Marketing Assistant is Ready!</p>}
            description={<p className="text-[#FFFFFF] text-xl mt-3 leading-relaxed">
                Just a few more details—then sit back and{' '}
                <span className="relative border border-[#FDB022] text-[#F79009] font-semibold px-1.5 py-0.5 bg-[#325142] inline-block">
                    <span className="absolute h-[5px] w-[5px] top-[-3px]  left-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] top-[-3px]  right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] left-[-3px] bg-[#FDB022]"></span>

                    let AI track,
                </span>{' '}
                analyze, and{' '}
                <span className="relative border border-[#FDB022] text-[#F79009] font-semibold px-1.5 py-0.5 bg-[#325142] inline-block">
                    <span className="absolute h-[5px] w-[5px] top-[-3px]  left-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] top-[-3px]  right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    optimize
                </span>{' '}
                your marketing performance effortlessly.
            </p>}
            background={BackgroundImg}
            icon={<AiChipsSignup className="h-[80px] w-[80px] " />}
            percent={30}
            currentStep={2}
        >
            <div className="h-[calc(100vh-21rem)] max-w-[480px] mx-auto w-full">
                <div className="text-center mt-8">
                    <div className="border border-gray-300 w-[56px] h-[56px] rounded-xl flex items-center justify-center m-auto shadow-sm">
                        <SetPasswordIcon className="w-[28px] h-auto" />
                    </div>
                    <p className="text-[#181D27] font-semibold text-3xl mt-4">Set Password</p>
                    <p className="text-[#535862] text-md mt-2">Set a unique password that is easy to remember</p>
                </div>
                <form onSubmit={handleSubmit(handleSignUp, handleSubmitError)} className="flex flex-col items-center justify-between mt-6 h-full gap-6">
                    <div className="max-w-[416px] w-full rounded-2xl flex flex-col space-y-4 md:space-y-4 h-full">

                        <InputField
                            control={control}
                            label={'Password'}
                            placeholder={'Enter password'}
                            name="password"
                            rules={{
                                required: 'Password is required',
                                ...validationConstants.password,
                            }}
                            error={errors.password}
                        />
                        <InputField
                            control={control}
                            label={'Confirm password'}
                            placeholder={'Repeat password'}
                            name="confirmPassword"
                            rules={{
                                required: 'Confirm password is required',
                                ...validationConstants.confirmPassword,
                            }}
                            error={errors.confirmPassword}
                        />

                        <p className="flex gap-2 items-center text-sm">
                            <CheckIcon
                                className={`h-5 w-5 p-1 rounded-full text-white transition-colors duration-300 ${isMinLength ? "bg-green-500" : "bg-[#D5D7DA]"
                                    }`}
                            />
                            <span
                                className={`transition-colors duration-300 ${isMinLength ? "text-green-600" : "text-[#535862]"}`}
                            >
                                Must be at least 8 characters
                            </span>
                        </p>

                        <p className="flex gap-2 items-center text-sm">
                            <CheckIcon
                                className={`h-5 w-5 p-1 rounded-full text-white transition-colors duration-300 ${hasSpecialChar ? "bg-green-500" : "bg-[#D5D7DA]"}`}
                            />
                            <span
                                className={`transition-colors duration-300 ${hasSpecialChar ? "text-green-600" : "text-[#535862]"}`}
                            >
                                Must contain one special character
                            </span>
                        </p>

                        {error && (
                            <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-gray-600 pt-4">
                                <p className='text-red-500 text-sm'>{error}</p>
                                <Icons icon={"heroicons-outline:x-circle"} className="max-h-5 max-w-5 h-5 w-5 text-red-500 cursor-pointer" onClick={() => setError(null)} />
                            </div>
                        )}
                    </div>

                    <Button
                        type='primary'
                        className="w-full max-w-[416px]"
                        disabled={loading}
                        loading={loading}
                        htmlType="submit"
                    >
                        Continue
                    </Button>
                </form>
            </div>
        </SignupLayout>
    )
};

export default SetPassword;
